<template>
    <div>
        <b-modal v-bind="$attrs" :id="id" :hide-header="resolvedHideHeader" no-close-on-backdrop @hidden="handleHidden"
            data-legacy
            ref="modal">
            <div style="min-height: 10rem" v-loading="loading">
                <template v-if="hasError">{{ error }}</template>
                <template v-else>
                    <component :is="content" @submit="handleSubmit" @cancel="handleCancel" />
                </template>
            </div>
        </b-modal>
        <vue-progress-bar></vue-progress-bar>
    </div>
</template>

<script>
    import PartialRenderer from './PartialRenderer';
    import { BModal } from 'bootstrap-vue';

    function extendableOptions(vm) {
        let { components, directives, filters } = vm.$options;
        return {
            components,
            directives,
            filters
        }
    }

    export default {
        name: 'RemoteModal',
        components: {
            BModal
        },
        props: {
            id: {
                type: String,
                default: null
            },
            url: String,
            hideHeader: Boolean,
            partialName: String
        },
        data() {
            return {
                show: false,
                loading: false,
                content: null,
                error: '',
                remoteUrl: this.url
            }
        },
        computed: {
            partialSelector() {
                return this.partialName ? `partial[name="${this.partialName}"]` : 'partial';
            },
            hasError() {
                return !!this.error;
            },
            resolvedHideHeader() {
                return this.hideHeader && !this.hasError;
            },
        },
        methods: {
            mountPartial(html) {
                let doc = new DOMParser().parseFromString(html, 'text/html');
                let partialEl = doc.querySelector(this.partialSelector);
                if(!partialEl) {
                    return Promise.reject(`remote-modal: can't find partial ${this.partialName ? `with name '${this.partialName}'` : ''} in ${this.remoteUrl}`);
                }
                this.loading = false;
                return new Promise(resolve => {
                    this.content = {
                        name:'RemoteContent',
                        extends: extendableOptions(this.$root),
                        template: partialEl.outerHTML,
                        components: {
                            partial: PartialRenderer
                        },
                        computed: {
                            partial() { return this.$children[0] }
                        },
                        mounted() {
                            resolve(this.partial);
                        }
                    };
                });
            },
            mountRoot(html) {
                document.open();
                document.write(html);
                document.close();
                window.scroll(0,0);
            },
            historyPush(url) {
                if(!(history.state||{}).fromRemoteModal) {
                    history.replaceState({ fromRemoteModal:true }, null, location.href);
                }
                history.pushState({ fromRemoteModal:true }, null, url);
            },
            async handleError(error) {
                let message = '';
                if(error instanceof Response) {
                    let response = error;
                    if(response.redirect) {
                        // const html = await response.text();
                        // this.$refs.modal.hide();
                        location.href = response.url;
                        // this.mountRoot(html);
                        // if(response.url !== location.href) {
                        //     this.historyPush(response.url);
                        // }
                        return;
                    }
                    else if(!response.ok) {
                        message = error.statusText;
                    }
                } else {
                    console.error(error);
                }
                this.loading = false;
                this.error = `Erreur lors du chargement de la page${ message ? ` : ${message}` : ''}`;
            },
            resolvePage(request) {
                this.loading = true;
                this.error = '';
                return Promise.resolve(request)
                    .then(response => {
                        if(!response.ok) {
                            return Promise.reject(response);
                        }
                        return response.text()
                    })
                    .then(this.mountPartial)
                    .catch(this.handleError)
                    .finally(()=> {
                        this.$Progress.finish();
                    });
            },
            handleSubmit(requestOptions) {
                let { url, ...options } = requestOptions;
                let request = new Request(url, {
                    ...options,
                    referrer: this.remoteUrl,
                    credentials: 'same-origin',
                    headers: {
                        'X-Remote-Modal': true,
                    },
                });
                this.$Progress.start();
                let post = fetch(request).then(response => {
                    if(response.url !== this.remoteUrl) {
                        // noinspection JSUndefinedPropertyAssignment
                        response.redirect = true;
                        return Promise.reject(response);
                    }
                    return response;
                });
                this.resolvePage(post).then(partial => {
                    console.log(partial);
                });
            },
            handleShow(id, target={}) {
                if(id !== this.id) return;

                this.remoteUrl = target.href || this.url;
                if(!this.remoteUrl) {
                    console.error('remote-modal: no url found');
                    return;
                }
                this.$refs.modal.show();
                this.resolvePage(
                    fetch(this.remoteUrl, { credentials:'same-origin' })
                );
            },
            handleHidden() {
                this.content = null;
            },
            handleCancel(){
                this.$refs.modal.hide();
            },
            handlePopState(e) {
                if((e.state||{}).fromRemoteModal) {
                    location.reload();
                }
            }
        },
        created() {
            this.$root.$on('remote-modal::show', this.handleShow);
            window.addEventListener('popstate', this.handlePopState);
        }
    }
</script>
